import React from 'react';
import { AssignmentCard } from '../../../components/assignmentCard';
import { ActivePathwayOverview } from '../models/assignment';
import StepIcons from '../../../components/StepIcons';
import windowService from '../../../services/windowService';

type TrainingAssignmentCardProps = {
  assignment: ActivePathwayOverview;
};

export function TrainingAssignmentCard({ assignment }: TrainingAssignmentCardProps) {
  const activeCourse = assignment.activeCourse;
  const upNext = activeCourse?.upNext;

  const completedCourses = assignment.progress.steps.completed;
  const totalCourses = assignment.progress.steps.total;
  const steps = activeCourse?.progress.steps;
  const trainingProgress = activeCourse?.progress.percent;

  const handleRedirectToTask = () => {
    localStorage.setItem('routeBeforeSteps', window.location.hash);
    windowService.redirectTo(
      '#/training-steps/' + assignment.instanceId + `?stepId=${upNext?.instanceId}&isWorkflow=true`
    );
  };

  return (
    <AssignmentCard data-qa-hook="assignmentCard">
      <AssignmentCard.Header
        currentCourse={completedCourses + 1}
        totalCourses={totalCourses}
        pathwayName={assignment.name}
      />
      <AssignmentCard.Body>
        <AssignmentCard.Poster src={assignment.posterImage} fallbackName={assignment.name} />
        <AssignmentCard.Content>
          <AssignmentCard.Title name={activeCourse.name} onClick={handleRedirectToTask} />
          <AssignmentCard.Metadata
            type="pathway"
            stepsCompleted={steps?.completed}
            stepsTotal={steps?.total}
            stepLabel="step"
            dueDate={assignment.dueDate}
          />
          <AssignmentCard.Progress variant="course" segments={[trainingProgress ?? 0]} />
        </AssignmentCard.Content>
      </AssignmentCard.Body>
      {upNext && (
        <AssignmentCard.Footer>
          <AssignmentCard.UpNext
            name={upNext.name}
            iconClass={StepIcons[upNext._type as keyof typeof StepIcons]}
            onClick={handleRedirectToTask}
          />
        </AssignmentCard.Footer>
      )}
    </AssignmentCard>
  );
}
